var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var GraduationCap = function GraduationCap(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.034 2.115a1 1 0 0 1 .932 0l9.5 5a1 1 0 0 1 0 1.77L20 10.183V18a1 1 0 0 1-.293.707L19 18l.707.707-.001.001-.002.002-.003.003-.01.01a2.758 2.758 0 0 1-.138.129c-.09.08-.22.192-.387.323-.331.263-.814.607-1.43.95A10.774 10.774 0 0 1 12.5 21.5c-2.212 0-4.004-.691-5.236-1.376a10.74 10.74 0 0 1-1.43-.948 8.073 8.073 0 0 1-.525-.453l-.01-.01-.003-.003-.002-.002L6 18l-.707.707A1 1 0 0 1 5 18v-7.817l-1-.527V14a1 1 0 1 1-2 0V8a.996.996 0 0 1 .553-.895l9.481-4.99Zm.932 11.77L18 11.235v6.313a8.743 8.743 0 0 1-1.236.828A8.774 8.774 0 0 1 12.5 19.5a8.774 8.774 0 0 1-4.264-1.124A8.739 8.739 0 0 1 7 17.547v-6.312l5.034 2.65a1 1 0 0 0 .932 0ZM5.147 8l7.353 3.87L19.853 8 12.5 4.13 5.147 8Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default GraduationCap;